import axios from 'axios';
import {
  API_BASE_LAB_TEMPLATES_URL,
  API_LAB_TEMPLATES_LIST,
  API_LAB_TEMPLATES_DETAILS,
  API_LAB_TEMPLATES_CREATE,
  API_LAB_TEMPLATES_UPDATE,
  API_LAB_TEMPLATES_DELETE,
  API_LAB_TEMPLATES_BY_CODE,
  API_LAB_TEMPLATES_CATEGORIES,
  API_LAB_TEMPLATES_BULK_CREATE
} from '../../../helpers/urlHelper';

// Configuración base de axios
const apiClient = axios.create({
  baseURL: API_BASE_LAB_TEMPLATES_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejo de errores
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// ========================================================================
// 🧪 SERVICIOS DE PLANTILLAS DE PRUEBAS DE LABORATORIO
// ========================================================================

export const labTemplateService = {
  /**
   * Obtener todas las plantillas de laboratorio
   */
  getAllTemplates: async () => {
    try {
      const response = await apiClient.get(API_LAB_TEMPLATES_LIST);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener plantillas: ${error.message}`);
    }
  },

  /**
   * Obtener plantilla por ID
   */
  getTemplateById: async (id) => {
    try {
      const response = await apiClient.get(`${API_LAB_TEMPLATES_DETAILS}/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener plantilla ${id}: ${error.message}`);
    }
  },

  /**
   * Obtener plantilla por código
   */
  getTemplateByCode: async (code) => {
    try {
      const response = await apiClient.get(`${API_LAB_TEMPLATES_BY_CODE}/${code}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener plantilla con código ${code}: ${error.message}`);
    }
  },

  /**
   * Obtener categorías de plantillas
   */
  getCategories: async () => {
    try {
      const response = await apiClient.get(API_LAB_TEMPLATES_CATEGORIES);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener categorías: ${error.message}`);
    }
  },

  /**
   * Crear nueva plantilla
   */
  createTemplate: async (templateData) => {
    try {
      const response = await apiClient.post(API_LAB_TEMPLATES_CREATE, templateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error al crear plantilla: ${error.message}`);
    }
  },

  /**
   * Crear múltiples plantillas (importación masiva)
   */
  createMultipleTemplates: async (templatesArray) => {
    try {
      const response = await apiClient.post(API_LAB_TEMPLATES_BULK_CREATE, {
        templates: templatesArray
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error al crear plantillas masivamente: ${error.message}`);
    }
  },

  /**
   * Actualizar plantilla
   */
  updateTemplate: async (id, templateData) => {
    try {
      const response = await apiClient.put(`${API_LAB_TEMPLATES_UPDATE}/${id}`, templateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error al actualizar plantilla ${id}: ${error.message}`);
    }
  },

  /**
   * Eliminar plantilla
   */
  deleteTemplate: async (id) => {
    try {
      const response = await apiClient.delete(`${API_LAB_TEMPLATES_DELETE}/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al eliminar plantilla ${id}: ${error.message}`);
    }
  },

  /**
   * Buscar plantillas por categoría
   */
  getTemplatesByCategory: async (category) => {
    try {
      const response = await apiClient.get(`${API_LAB_TEMPLATES_LIST}?category=${category}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al buscar plantillas de categoría ${category}: ${error.message}`);
    }
  },

  /**
   * Buscar plantillas por texto
   */
  searchTemplates: async (searchTerm) => {
    try {
      const response = await apiClient.get(`${API_LAB_TEMPLATES_LIST}?search=${searchTerm}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al buscar plantillas: ${error.message}`);
    }
  }
};

export default labTemplateService;